export const createMarkup = (htmlString) => ({ __html: htmlString });
